import { Box } from '@betterment/samba-react';
import { styled } from '@betterment/samba-styled-system/jsx';
import { SystemStyleObject } from '@betterment/samba-styled-system/types';

const SplitFlowContainer = styled('div', {
  base: {
    display: 'grid',
    sm: {
      gridTemplateColumns: '1fr',
    },
    lg: {
      gridTemplateColumns: '2fr 3fr',
      position: 'fixed',
      top: '0',
      bottom: '0',
      right: '0',
      left: '0',
    },
  },
});

const ImagePane = styled('div', {
  base: {
    width: '100%',
    sm: {
      maxHeight: '40vh',
    },
    lg: {
      maxHeight: '100vh',
      gridRow: '1 / 3',
    },
  },
});

const Image = styled('img', {
  base: {
    backgroundColor: 'primitives.teal.50',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    objectPosition: 'center',
  },
});

const Content = styled('div', {
  base: {
    display: 'grid',
    gap: 'space.400',
    lg: {
      maxHeight: '100vh',
      overflow: 'auto',
      gridColumn: '2 / 3',
    },
  },
});

const Header = styled('div', {
  base: {
    width: '100%',
    borderBottom: 'solid 1px',
    borderColor: 'border',
    lg: {
      gridColumn: '2 / 3',
    },
  },
});

const Root: React.FC<React.PropsWithChildren<{ css?: SystemStyleObject }>> = ({ children, css }) => (
  <Box
    css={{
      containerType: 'inline-size',
      ...css,
    }}
  >
    <SplitFlowContainer>{children}</SplitFlowContainer>
  </Box>
);

const SplitFlow = Object.assign(Root, { Image, ImagePane, Content, Header });

SplitFlow.Image.displayName = 'SplitFlow.Image';
SplitFlow.ImagePane.displayName = 'SplitFlow.ImagePane';
SplitFlow.Content.displayName = 'SplitFlow.Content';
SplitFlow.Header.displayName = 'SplitFlow.Header';
SplitFlow.displayName = 'SplitFlow';

export default SplitFlow;
